import React from 'react';

import Icon, { IconProps } from '../../icon';
import useStyles from './styles';

export const Close = (): string => {
  const classes = useStyles();
  return classes.close;
};

export const CloseIcon = (props: IconProps): JSX.Element => {
  const classes = useStyles();
  return <Icon icon={classes.close} {...props} />;
};
